export const OBSERVABLE_UNITS = {
  ALL: false,
  OBSERVABLE_ONLY: true
};
